import { memo } from 'react';
import { NavLink } from 'react-router-dom';

import { CornerBadge } from '../../Components/PuzzleNav/components/CornerBadge.tsx';
import { usePathMatch } from '../../Components/PuzzleNav/hooks/index.ts';
import { RibbonVariant } from '../../Components/PuzzleNav/types.ts';
import { TabWrapper, Title } from './styled.ts';
import type { TabsGroupNavigationItemProps } from './types.ts';

export const NavigationItem = memo(function NavigationItem({
  title,
  exact,
  path,
  to,
  dataTestId = `nav-tab-${to}`,
  hidden,
  isNew,
}: TabsGroupNavigationItemProps) {
  const match = usePathMatch({ path: path ?? to, exact });

  if (hidden) {
    return null;
  }

  return (
    <TabWrapper to={to} as={NavLink} $active={match} data-testid={dataTestId}>
      {isNew && <CornerBadge variant={RibbonVariant.NEW} />}
      <Title $active={match}>{title}</Title>
    </TabWrapper>
  );
});
